export class DocumentData {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
